import { parseInlineCitationList } from "@hightouch/lib/llm/inline-citation-tags";
import { useInlineCitationsContext } from "./inline-citations-context";
import { CitationsPill } from "./citations-pill";
import { resolveParagraphCitedEntries } from "./derive-session-context";
import { useSessionContextPanelEnabled } from "./use-session-context-panel-enabled";

type Props = {
  assumptions?: string;
  referenced?: string;
};

export const InlineCitations = ({ assumptions, referenced }: Props) => {
  const isEnabled = useSessionContextPanelEnabled();
  const citationsContext = useInlineCitationsContext();
  if (!isEnabled || !citationsContext) return null;

  const {
    interactionId,
    interactionCitations,
    resolveLookedUpCitations,
    setView,
  } = citationsContext;
  const refs = {
    assumptionKeys: parseInlineCitationList(assumptions),
    referencedIds: parseInlineCitationList(referenced),
  };
  const citedEntries = resolveParagraphCitedEntries(interactionCitations, refs);
  const citations =
    citedEntries.length > 0 ? resolveLookedUpCitations(citedEntries) : null;
  if (!citations) return null;

  return (
    <CitationsPill
      variant="inline"
      citations={citations}
      onClick={() => setView({ kind: "paragraph", interactionId, ...refs })}
      onSelectCitation={(citation) =>
        setView({
          kind: "paragraph",
          interactionId,
          ...refs,
          focusedCitedEntry: citation.citedEntry,
        })
      }
    />
  );
};
